import { t } from 'i18next';
import { useMemo } from 'react';

import {
  CommonFlex,
  CommonGrid,
  CommonText,
} from '../../styledComponents/common';
import TransactionReportColumn from './transactionReportColumn';
import { all } from 'axios';

const ZONE_NAMES = ['Mina', 'Arafat'];

const ItemTransactionChart = ({ itemTransactionsDashboardData = [] }) => {
  const formattedData = useMemo(() => {
    if (!itemTransactionsDashboardData?.length) return [];

    return itemTransactionsDashboardData.map(office => {
      const formattedItems = office.items.map(item => {
        return {
          id: item.item_id,
          name: item.item_name,
          officeName: office.office_name,
          required_quantity: item.allotted_quantity,
          innerChartData: {
            current_quantity: item.current_quantity,
            remaining: item.remaining,
            allotted_quantity: item.allotted_quantity,
            // remaining: item.current_quantity >= item.allotted_quantity ? 0 : item.remaining
          },
          outerChartData: {
            not_received: item.not_received || 0,
            theft: item.theft || 0,
            lost: item.missing || 0,
            transferred: item.transferred || 0,
            damaged: item.damaged || 0,
          },
        };
      });

      return {
        officeId: office.office_id,
        officeName: office.office_name,
        zoneId: office.public_zone_id,
        zoneName: office.public_zone_name,
        items: formattedItems,
      };
    });
  }, [itemTransactionsDashboardData]);

  const zoneGrouped = useMemo(() => {
    const groups = {};

    formattedData.forEach(data => {
      if (!groups[data.zoneName]) {
        groups[data.zoneName] = {
          zoneId: data.zoneId,
          zoneName: data.zoneName,
          items: [],
        };
      }

      // Add items to the zone
      groups[data.zoneName].items.push(...data.items);
    });

    return Object.values(groups);
  }, [formattedData]);

  if (!itemTransactionsDashboardData?.length) {
    return (
      <CommonFlex justifyContent="center" margin="30px 0">
        <CommonText>{t('no_data_available')}</CommonText>
      </CommonFlex>
    );
  }

  // Create map of existing zones
  const existingZones = zoneGrouped.reduce((acc, zone) => {
    acc[zone.zoneName] = zone;
    return acc;
  }, {});

  return (
    <div>
      <CommonGrid gap="20px" columns="1fr 1fr">
        {ZONE_NAMES.map((zoneName, index) => {
          // If this zone exists in our data, display it
          if (existingZones[zoneName]) {
            const zone = existingZones[zoneName];
            return (
              <TransactionReportColumn
                key={zone.zoneId || `zone-${index}`}
                title={zone.zoneName}
                data={zone.items}
              />
            );
          }
          // Otherwise show empty column with proper zone name
          return (
            <TransactionReportColumn
              key={`empty-${index}`}
              title={zoneName}
              data={[]}
            />
          );
        })}
      </CommonGrid>
    </div>
  );
};

export default ItemTransactionChart;
